import React, { useState } from "react";
import "./../styles/Faq.css";

const Faq = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const faqs = [
    {
      question: "How do I change my password?",
      answer: "Go to your profile settings and click on 'Change Password'. Follow the steps provided."
    },
    {
      question: "How can I update my profile picture?",
      answer: "Open your account profile, tap 'Edit Profile Picture', then upload a new image."
    },
    {
      question: "How do I change my email for notifications?",
      answer: "Navigate to 'Account Settings' and update your notification email."
    },
    {
      question: "How do I view my transaction history?",
      answer: "Open the 'Transactions' section to view all your credits and debits."
    },
    {
      question: "How can I contact support?",
      answer: "Use the live chat button or the 'Contact Support' page."
    },
    {
      question: "How do I make a transfer?",
      answer: "Click on 'Make a Transfer', fill in account details, enter amount, and confirm."
    },
  ];

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="faq-container">
      <h2 className="faq-title">How Can We Help You?</h2>

      {faqs.map((faq, index) => (
        <div key={index} className="faq-item">
          <div className="faq-question" onClick={() => toggleFAQ(index)}>
            <span>{faq.question}</span>
            <span className="faq-icon">{activeIndex === index ? "−" : "+"}</span>
          </div>

          {activeIndex === index && (
            <div className="faq-answer">{faq.answer}</div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Faq;
